<template>
  <li
    class="sidebar__nav-menu-list-item"
    @click="$emit('click')"
  >
    <BaseLink
      v-bind="dynamicProps"
      :href="href"
      :target="target"
      class="nav-link sidebar__nav-menu-link"
    >
      <font-awesome-icon
        class="fa-fw mr-2 sidebar__nav-menu-icon"
        :icon="menuIcon"
      />
      <span class="sidebar__nav-menu-text">
        {{ menuText }}
      </span>
      <b-badge
        v-if="badge"
        variant="primary"
        class="ml-2"
      >
        {{ badge }}
      </b-badge>
    </BaseLink>
  </li>
</template>

<script>
export default {
  name: 'SidebarNavItem',

  props: {
    route: {
      type: [Object, String],
      default() {
        return ''
      }
    },

    menuText: {
      type: String,
      default: ''
    },

    href: {
      type: String,
      default: ''
    },

    menuIcon: {
      type: Array,
      default() {
        return []
      }
    },
    exact: {
      type: Boolean,
      default: false
    },
    badge: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: '_self'
    }
  },

  computed: {
    dynamicProps() {
      return this.route ? { to: this.route, exact: this.exact } : {}
    }
  },
}
</script>

<style>

</style>